import request from '@/config/axios'

export interface ChatbotMessage {
  id: number
  conversationId: number
  replyId?: number
  type: string
  userId?: number
  roleId?: number
  roleName?: string
  model?: string
  content: string
  createTime?: string
}

export interface ChatbotConversation {
  id: number
  userId: number
  title: string
  roleId?: number
  roleName?: string
  roleAvatar?: string
  model?: string
  modelName?: string
  messageCount?: number
  createTime?: string
  messages?: ChatbotMessage[]
}

export const getChatbotConversations = (params: { pageNo: number; pageSize: number }) =>
  request.get<{ list: ChatbotConversation[]; total: number }>({
    url: '/ai/chat/conversation/page',
    params
  })

export const getChatbotMessages = (conversationId: number) =>
  request.get<{ list: ChatbotMessage[]; total: number }>({
    url: '/ai/chat/message/page',
    params: { conversationId, pageNo: 1, pageSize: 100 }
  })
